import type { GetWizardsResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetWizardsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetWizardsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetWizards = createQueryHook<
  Record<string, never>,
  GetWizardsResponseRow[],
  GetWizardsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.wizard.wizards.queryOptions(),
  // Legacy query root is the flat `wizard` array; the tRPC procedure returns
  // the unwrapped rows.
  mapTrpcDataToGraphQL: (data) => ({
    wizard: data,
  }),
  graphqlDocument: GetWizardsDocument,
  // The assessment-form field consumer co-mounts other reads; cache-first keeps
  // the read shared and avoids the no-cache console.warn promoted to FATAL in
  // packages/web vitest.
  graphqlFetchPolicy: 'cache-first',
});
